exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#chart svg{max-width:100%;overflow:visible!important;pointer-events:none}#chart text{font-size:13px;fill:#000!important}@media screen and (max-width:800px){#chart text{font-size:12px}}@media screen and (max-width:600px){#chart text{font-size:11px}}#chart g.tick:last-child line{fill:#000!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-12b03208","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Graph.vue
// module id = 870
// module chunks = 0